// extracted by mini-css-extract-plugin
module.exports = {"container":"Header_container__18NGJ","divider":"Header_divider__3vhNx","prevNextButton":"Header_prevNextButton__1gqZz"};